import { BACK_TYPE, PRESCRIPTION_FULFILLMENT_OPTION, Step, STEP_TYPE } from '@abiglobalhealth/go-types'
import { Dispatch, SetStateAction, useContext } from 'react'

import { JourneyContext } from '@/contexts/journey'

interface UseStepProps {
  currentStep: Step | undefined
  updateStep: (step: Step) => void
  setCurrentStep: Dispatch<SetStateAction<Step | undefined>>
  updateFulfillmentStep: ({ option, backButton }: { option: PRESCRIPTION_FULFILLMENT_OPTION | null; backButton?: BACK_TYPE | undefined }) => void
}

export const useStep = (): UseStepProps => {
  const { currentStep, setCurrentStep } = useContext(JourneyContext)

  const updateStep = (step: Step) => {
    setCurrentStep(step)
  }

  const updateFulfillmentStep = ({ option, backButton }: { option: PRESCRIPTION_FULFILLMENT_OPTION | null; backButton?: BACK_TYPE | undefined }) => {
    updateStep({
      id: 'fulfillment-choice-selection',
      name: 'Fulfillment Choice Selection',
      components: {},
      componentsOrder: [],

      option,
      type: STEP_TYPE.FULFILLMENT_CHOICE_SELECTION,
      backButton
    })
  }

  return {
    currentStep,
    updateStep,
    setCurrentStep,
    updateFulfillmentStep
  }
}
